var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.63867V11.9244",
    stroke: "#F2A93B",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.9242C10.3945 16.9242 10.7143 16.6044 10.7143 16.2099C10.7143 15.8154 10.3945 15.4956 10 15.4956C9.60551 15.4956 9.28571 15.8154 9.28571 16.2099C9.28571 16.6044 9.60551 16.9242 10 16.9242Z",
    stroke: "#F2A93B",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2714 1.99571C11.1515 1.7617 10.9694 1.56532 10.7451 1.4282C10.5207 1.29107 10.2629 1.21851 10 1.21851C9.73708 1.21851 9.47925 1.29107 9.25492 1.4282C9.03059 1.56532 8.84845 1.7617 8.72857 1.99571L0.871429 17.71C0.761843 17.9275 0.709669 18.1693 0.719861 18.4126C0.730053 18.656 0.802273 18.8926 0.929662 19.1002C1.05705 19.3077 1.23538 19.4792 1.44771 19.5985C1.66005 19.7177 1.89934 19.7807 2.14286 19.7814H17.8571C18.1007 19.7807 18.34 19.7177 18.5523 19.5985C18.7646 19.4792 18.9429 19.3077 19.0703 19.1002C19.1977 18.8926 19.2699 18.656 19.2801 18.4126C19.2903 18.1693 19.2382 17.9275 19.1286 17.71L11.2714 1.99571Z",
    stroke: "#F2A93B",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorning);
export default __webpack_public_path__ + "static/media/worning.f386172ac83f3e6537d12cbe8b3762f4.svg";
export { ForwardRef as ReactComponent };